// 账号检测
export const checkAccount = account => {
  return {
    url: `/check-account/${account}`,
    method: 'get'
  }
}
export const login = vmParam => {
  return {
    url: '/login',
    method: 'post',
    data: vmParam
  }
}
export const signUp = vmParam => {
  return {
    url: '/sign-up',
    method: 'post',
    data: vmParam
  }
}

// 创建店铺
export const createStore = vmParam => {
  return {
    url: '/create-store',
    method: 'post',
    data: vmParam
  }
}
// 查看卖家申请的店铺信息
export const storeApplyInfo = vmParam => {
  return {
    url: '/store-apply-info',
    method: 'get',
    params: vmParam // query参数
  }
}
// 登陆后传storeid给后台
export const storeId = storeId => {
  return {
    url: `/store/${storeId}/login`,
    method: 'get'
  }
}
// 刷新Token
export const refreshToken = vmParam => {
  return {
    url: '/session/token',
    method: 'post',
    data: vmParam
  }
}
// 获取银行相关信息列表
export const getBankList = ($axios, params) => $axios
  .get(`/v1/banks?regionCode=${params}`)
  .then(r => r.data?.data)

// 检测商家信息是否可用  idNumber个人身份证、企业营业执照编号 taxNumber税号
export const checkAvailabilityID = ($axios, params) => $axios
  .get('/v1/seller-info/check-availability', { params })
  .then(r => r.data?.data)

/* 检测店铺信息是否可用
* identifier：storeName店铺名称
* value: 值
*/
export const checkAvailabilityStore = ($axios, params) => $axios
  .get('/v1/store-info/check-availability', { params })
  .then(r => r.data?.data)

/* 检测店铺执照是否被其他店铺使用
* seller_id
* qualification_no: 营业执照号或身份证号
* 返回值中, same:表示同一账号下同样使用该id的店铺  other:表示非同一店铺的
*/
export const checkAvailabilityStoreIdNumber = ($axios, params) => $axios
  .get('/v1/store-info/check-qualification', { params })
  .then(r => r.data?.data)
/**
 *
 * @param {获取商家资质信息} $axios
 * @returns
 */
export const getSellerInfo = ($axios) => $axios
  .get('/v1/seller/info')
  .then(r => r.data?.data)
/**
 *
 * @param {编辑商家资质信息} $axios
 * @returns
 */
export const setSellerInfo = ($axios, params) => $axios
  .patch('/v1/seller/info', params)
  .then(r => r.data?.data)

/**
 * 获取商家资质信息
 */
export const getSellerDetail = ($axios) => $axios
  .get('/seller-detail')
  .then(r => r.data?.data)
